import { BaseManagementApi } from './api.base';

export class BoxManagementApi extends BaseManagementApi {

}
